import { isValidResolution } from '../FramingAndWorkingResolutionCalculators/components/FramingChart/validators/validateResolution';
import { round } from './round';
import { AspectRatio, Resolution } from './types';

type WithRawResult<T> = {
  rounded: T;
  raw: T;
};

/**
 * Calculates aspect ratio with optional lens squeeze factor support.
 *
 * Formula: (width * lensSqueezeFactor) / height
 *
 * @param dimensions - Resolution tuple [horizontal, vertical], Resolution object {width, height}, or CameraSensorMode
 * @param lensSqueezeFactor - Optional lens squeeze factor (defaults to 1)
 * @returns Object with both raw and rounded aspect ratios
 */
export function getAspectRatio(
  dimensions: Resolution,
  lensSqueezeFactor: number = 1
): WithRawResult<AspectRatio> {
  if (!isValidResolution(dimensions)) {
    throw new Error(
      'Invalid dimensions: width and height must be positive finite numbers'
    );
  }

  // Apply lens squeeze factor to the calculation
  const result = (dimensions.width * lensSqueezeFactor) / dimensions.height;
  const rounded = [round(result, 2), 1] as AspectRatio;
  const raw = [result, 1] as AspectRatio;

  return {
    rounded,
    raw,
  };
}
